<template>
  <div class="app-layout">
    <!-- Top Header -->
    <header class="top-header">
      <router-link to="/azure-ado-projects" class="brand">
        <svg viewBox="0 0 300 81.09" class="brand-logo">
          <path fill="currentColor" d="m300,46.19v2.96c-.04.13-.11.26-.12.4-.4,4.02-2.44,6.99-6.06,8.94-1.94,1.04-4.04,1.57-6.23,1.78-1.05.1-2.11.13-3.16.13-7.86.01-15.73,0-23.6,0h-.8c-.14-.47-.19-6.91-.06-8,.25,0,.52-.02.78-.02,7.93,0,15.86,0,23.79-.01.92,0,1.85-.13,2.77-.24.41-.06.81-.22,1.2-.38,1.07-.46,1.74-1.27,2.01-2.38.44-1.77,0-3.22-1.5-4.34-1.01-.74-2.13-1.27-3.29-1.71-2.4-.91-4.91-1.54-7.39-2.22-3.11-.85-6.22-1.7-9.2-2.96-2.03-.86-3.94-1.89-5.61-3.34-2.8-2.43-3.9-5.5-3.59-9.1.13-1.45.44-2.85,1.07-4.18,1.17-2.45,3.1-4.14,5.58-5.26,2.05-.94,4.23-1.43,6.48-1.62,1.32-.11,2.65-.15,3.98-.15,6.54-.02,13.07-.01,19.61-.01h.81c.14.45.19,7.2.05,8.04h-.73c-7.41,0-14.8,0-22.21.01-.79,0-1.6.09-2.38.24-1.87.38-2.73,1.4-2.91,3.25-.15,1.35.42,2.36,1.47,3.16.82.61,1.72,1.05,2.67,1.42,2.24.89,4.57,1.47,6.89,2.08,3.07.8,6.13,1.6,9.08,2.73,2.09.8,4.1,1.76,5.91,3.09,1.96,1.46,3.47,3.25,4.2,5.59.18.54.25,1.12.36,1.69.03.13.08.26.13.4"/>
          <path fill="currentColor" d="m253.53,59.53v.85h-8.93c0-.26-.02-.5-.02-.74v-23.33c0-1.15.06-2.31-.03-3.46-.38-4.88-2.72-8.52-7.41-10.43-6.73-2.74-14.32,1.17-15.95,8.11-.27,1.13-.38,2.27-.38,3.43v26.39h-8.88c-.02-.24-.04-.45-.04-.68,0-8.89-.06-17.77.02-26.67.04-5.09,1.72-9.63,5.34-13.4,2.4-2.5,5.31-4.2,8.68-5.15,5.12-1.46,10.25-1.37,15.23.57,6.46,2.53,10.38,7.23,11.89,13.85.36,1.56.5,3.14.5,4.73,0,8.64,0,17.28,0,25.93"/>
          <path fill="currentColor" d="m206.83,34.59c.08.95.14,1.89.17,2.44-.04,6.46-2.01,11.82-6.2,16.33-3.57,3.83-7.99,6.24-13.14,7.37-5.85,1.28-11.57.78-17.03-1.7-7.07-3.21-11.79-8.47-13.53-15.93-1.9-8.17-.13-15.57,5.75-21.82,3.56-3.79,8.03-6.13,13.18-7.18,6.99-1.42,13.61-.41,19.67,3.29,6.1,3.72,9.76,9.12,10.99,16.05.07.39.12.77.14,1.16m-10.5,9.51c1.82-4.39,1.82-8.87.03-13.27-1.71-4.22-4.86-7.03-9.26-8.47-2.97-.96-6.02-1.1-9.08-.44-5.39,1.15-9.18,4.24-11.14,9.3-1.55,4-1.54,8.08-.12,12.11,1.19,3.4,3.39,6.06,6.59,7.88,2.56,1.46,5.35,2.09,8.65,2.09,1.03.02,2.39-.11,3.74-.44,5.01-1.21,8.62-4.08,10.58-8.76"/>
          <path fill="currentColor" d="m148.03.26c2.4.72,3.83,2.82,3.6,5.24-.22,2.2-2.17,4.04-4.55,4.29-2.29.23-4.39-.86-5.33-2.78-1.31-2.68.15-5.87,3.11-6.74C145.13.18,145.41.09,145.68,0h1.66c.23.09.46.18.69.26"/>
          <path fill="currentColor" d="m150.83,14.51c.15.51.17,45.26.02,45.87h-8.73s-.03-.03-.05-.04c-.01-.01-.03-.02-.04-.04-.01-.06-.03-.13-.03-.18V14.8c0-.08.03-.16.05-.29h8.78Z"/>
          <path fill="currentColor" d="m136.56,52.38v7.99c-.25.01-.46.02-.67.02-3.97,0-7.95.03-11.92,0-2.64-.02-5.16-.61-7.44-1.96-3.05-1.8-4.82-4.5-5.72-7.8-.42-1.54-.62-3.12-.62-4.71-.01-14.46,0-28.93,0-43.39v-.78c.45-.15,7.97-.21,8.94-.06v12.77h17.34c.17.53.19,7.4.02,8.05h-17.31c-.02.24-.05.42-.05.6,0,7.84-.01,15.68,0,23.52,0,.77.1,1.57.29,2.32.36,1.45,1.31,2.42,2.76,2.91,1.23.43,2.52.51,3.81.51,3.26,0,6.51,0,9.77,0h.79Z"/>
          <path fill="currentColor" d="m104.72,36.4c.25,3.13-.04,6.17-1.04,9.16-2.59,7.78-9.51,13.76-17.74,15.37-2.77.54-5.54.54-8.34.25-3.26-.35-6.38-1.21-9.31-2.65-.25-.12-.48-.26-.74-.39v-8.68c.26-.07.43.13.61.24,2.57,1.52,5.31,2.64,8.25,3.24,3.86.79,7.62.4,11.19-1.28,3.61-1.71,6.03-4.49,7.29-8.18,1.41-4.15,1.41-8.33-.26-12.41-2.04-5.03-5.91-8.03-11.3-9.15-2.77-.58-5.55-.53-8.28.28-3.93,1.17-6.76,3.64-8.66,7.16-1.24,2.29-1.89,4.76-2.21,7.32-.18,1.56-.22,3.12-.22,4.69.01,12.96.01,25.92.01,38.87,0,.29-.01.58-.02.87h-8.88c-.03-.25-.06-.49-.06-.74,0-13.96-.02-27.92.01-41.9,0-4.89,1.08-9.54,3.66-13.78,3.52-5.79,8.74-9.31,15.47-10.65,4.92-.97,9.81-.71,14.56.92,6.58,2.25,11.16,6.61,13.9,12.82,1.22,2.76,1.86,5.64,2.09,8.62"/>
          <path fill="currentColor" d="m47.96,26.26c2.06,3.58,3.01,7.46,2.93,11.57-.14,6.13-2.41,11.4-6.73,15.83-3.96,4.05-8.8,6.51-14.46,7.37-7.35,1.11-14.09-.46-20.02-4.88-5.01-3.73-8.09-8.68-9.24-14.75-.08-.43-.1-.86-.18-1.28-.06-.34-.16-.67-.25-1v-3.34c.08-.3.19-.59.23-.89,1.1-8.3,5.56-14.35,12.98-18.41,2.31-1.26,4.8-2.06,7.38-2.54.12-.02.24-.02.41-.03v7.79c-.21.07-.43.13-.64.21-5.83,1.87-9.88,5.56-11.52,11.37-1.63,5.79-.12,10.94,4.09,15.29,2.81,2.89,6.33,4.51,10.36,5.01,8.05.98,15.95-3.47,18.54-10.98,2.09-6.07.72-11.52-3.7-16.21-2.11-2.24-4.74-3.7-7.73-4.55-.13-.03-.24-.07-.4-.12v-7.82c.29.04.58.07.85.13,7.53,1.66,13.3,5.66,17.1,12.23"/>
          <rect fill="currentColor" x="23.85" y="13.54" width="3.28" height="22.92"/>
        </svg>
        Cyanic Cloud
      </router-link>

      <div class="header-right">
        <div v-if="userIsLoggedIn && loggedInUser" class="user-info">
          <img
            :src="userPhoto || defaultPhoto"
            alt="Profile Photo"
            class="profile-photo"
          />
          <span class="user-name"
            >Logged in user:
            {{ loggedInUser.displayName || loggedInUser.upn }}</span
          >
        </div>

        <button v-if="userIsLoggedIn" @click="logout" class="logout-button">
          <svg
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          Logout
        </button>
      </div>
    </header>

    <!-- Left Sidebar -->
    <nav class="sidebar">
      <!-- ===== Main Navigation ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title">Main Navigation</div>

        <router-link
          to="/azure-ado-projects"
          class="nav-link"
          active-class="active"
        >
          <img src="@/assets/Microsoft-Azure-Emblem.png" alt="" class="nav-icon-img" />
          Projects
        </router-link>

        <router-link
          to="/fetch-json-files"
          class="nav-link"
          active-class="active"
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
          </svg>
          Aegis
        </router-link>
      </div>

      <div class="sidebar-divider"></div>

      <!-- ===== Tenant Selection ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title">Select Tenant</div>

        <router-link to="/entra/portfolio" class="nav-link nav-link-cta" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
          </svg>
          <span v-if="!currentTenantId">Select a Tenant</span>
          <span v-else class="tenant-selected-label">{{ currentTenantId.slice(0, 8) }}...</span>
        </router-link>
      </div>

      <div class="sidebar-divider"></div>

      <!-- ===== Microsoft Entra ID ===== -->
      <div v-if="currentTenantId" class="sidebar-section">
        <div class="sidebar-section-title section-title-with-logo">
          <img src="@/assets/entra.png" alt="" class="section-logo" />
          Microsoft Entra ID
        </div>

        <router-link :to="tenantPath + '/overview'" class="nav-link" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
          </svg>
          Overview
        </router-link>

        <!-- Identity -->
        <button class="nav-group-toggle" :class="{ expanded: expandedGroups.identity, 'nav-link-disabled': !currentTenantId }" @click="toggleGroup('identity')" :disabled="!currentTenantId">
          <svg class="toggle-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" width="14" height="14">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
          Identity
        </button>
        <div v-show="expandedGroups.identity" class="nav-group-items">
          <router-link :to="tenantPath + '/users'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Users
          </router-link>
          <router-link :to="tenantPath + '/groups'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Groups
          </router-link>
          <router-link :to="tenantPath + '/licences'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Licences
          </router-link>
        </div>

        <!-- Security -->
        <button class="nav-group-toggle" :class="{ expanded: expandedGroups.security, 'nav-link-disabled': !currentTenantId }" @click="toggleGroup('security')" :disabled="!currentTenantId">
          <svg class="toggle-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" width="14" height="14">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
          Security &amp; Compliance
        </button>
        <div v-show="expandedGroups.security" class="nav-group-items">
          <router-link :to="tenantPath + '/security'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Identity Security
          </router-link>
          <router-link :to="tenantPath + '/conditional-access'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Conditional Access
          </router-link>
          <router-link :to="tenantPath + '/authentication-methods'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Authentication Methods
          </router-link>
          <router-link :to="tenantPath + '/sign-in-logs'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Sign-in Logs
          </router-link>
        </div>

        <!-- Applications -->
        <button class="nav-group-toggle" :class="{ expanded: expandedGroups.applications, 'nav-link-disabled': !currentTenantId }" @click="toggleGroup('applications')" :disabled="!currentTenantId">
          <svg class="toggle-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" width="14" height="14">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
          Applications
        </button>
        <div v-show="expandedGroups.applications" class="nav-group-items">
          <router-link :to="tenantPath + '/applications'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            App Registrations
          </router-link>
        </div>

        <!-- Teams -->
        <router-link :to="tenantPath + '/teams'" class="nav-link" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          Teams
        </router-link>

        <!-- Operations -->
        <button class="nav-group-toggle" :class="{ expanded: expandedGroups.operations, 'nav-link-disabled': !currentTenantId }" @click="toggleGroup('operations')" :disabled="!currentTenantId">
          <svg class="toggle-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" width="14" height="14">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
          Operations
        </button>
        <div v-show="expandedGroups.operations" class="nav-group-items">
          <router-link :to="tenantPath + '/recommendations'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Recommendations
          </router-link>
          <router-link :to="tenantPath + '/activity'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Activity
          </router-link>
          <router-link :to="tenantPath + '/reports'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
            Reports
          </router-link>
        </div>

        <router-link :to="tenantPath + '/settings'" class="nav-link" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          Settings
        </router-link>
      </div>

      <div v-if="currentTenantId" class="sidebar-divider"></div>

      <!-- ===== Microsoft Intune ===== -->
      <div v-if="currentTenantId" class="sidebar-section">
        <div class="sidebar-section-title section-title-with-logo">
          <img src="@/assets/Intune.png" alt="" class="section-logo" />
          Microsoft Intune
        </div>

        <router-link :to="tenantPath + '/intune'" class="nav-link" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
          </svg>
          Overview
        </router-link>
        <router-link :to="tenantPath + '/intune/devices'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          Devices
        </router-link>
        <router-link :to="tenantPath + '/intune/compliance'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          Compliance Policies
        </router-link>
        <router-link :to="tenantPath + '/intune/configs'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          Device Configurations
        </router-link>
        <router-link :to="tenantPath + '/intune/app-protection'" class="nav-link nav-link-sub" :class="{ 'nav-link-disabled': !currentTenantId }" active-class="active">
          App Protection
        </router-link>
      </div>

      <div v-if="currentTenantId" class="sidebar-divider"></div>

      <!-- ===== Microsoft 365 ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title section-title-with-logo">
          <img src="@/assets/Microsoft_logo.png" alt="" class="section-logo" />
          Microsoft 365
        </div>

        <router-link to="/tenant-baseline-options" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
          Tenant Baseline
        </router-link>

        <router-link to="/capture-management" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/>
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          Capture Management
        </router-link>

        <router-link to="/trigger-capture" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
          </svg>
          Trigger Capture
        </router-link>

        <router-link to="/tenant-backup" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 7v10c0 2 1 3 3 3h10c2 0 3-1 3-3V7M4 7c0-2 1-3 3-3h10c2 0 3 1 3 3M4 7h16M12 11v4M9 15h6"/>
          </svg>
          Tenant Backups
        </router-link>

        <router-link to="/JIT-Admin-Process" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
          Just-In-Time (JIT Access)
        </router-link>
      </div>

      <div class="sidebar-divider"></div>

      <!-- ===== Netskope ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title section-title-with-logo">
          <img src="@/assets/netskope.jpg" alt="" class="section-logo" />
          Netskope
        </div>

        <router-link to="/netskope-baseline" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 7v10c0 2 1 3 3 3h10c2 0 3-1 3-3V7M4 7c0-2 1-3 3-3h10c2 0 3 1 3 3M4 7h16"/>
          </svg>
          Baseline Deployment
        </router-link>
      </div>

      <div class="sidebar-divider"></div>

      <!-- ===== Microsoft Billing ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title section-title-with-logo">
          <img src="@/assets/Microsoft_logo.png" alt="" class="section-logo" />
          Microsoft Billing
        </div>

        <router-link to="/billing/dashboard" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 19.496 6.996 20 6.375 20h-2.25A1.125 1.125 0 013 18.875v-5.75zM8.25 6.625C8.25 6.004 8.754 5.5 9.375 5.5h2.25c.621 0 1.125.504 1.125 1.125v12.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V6.625zM13.5 10.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v9.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125v-9.25z"/>
          </svg>
          Dashboard
        </router-link>

        <router-link to="/billing/invoices" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          Invoices
        </router-link>

        <router-link to="/billing/customers" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          Customers
        </router-link>

        <router-link to="/billing/internal" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"/>
          </svg>
          Internal Spend
        </router-link>

        <router-link to="/billing/recon" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          Recon Processing
        </router-link>

        <router-link to="/billing/recon/overview" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 19.496 6.996 20 6.375 20h-2.25A1.125 1.125 0 013 18.875v-5.75zM8.25 6.625C8.25 6.004 8.754 5.5 9.375 5.5h2.25c.621 0 1.125.504 1.125 1.125v12.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V6.625zM13.5 10.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v9.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125v-9.25z"/>
          </svg>
          Recon Overview
        </router-link>

        <router-link to="/billing/recon/profitability" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Recon Profitability
        </router-link>

        <router-link to="/billing/recon/config" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          Recon Config
        </router-link>
      </div>

      <div class="sidebar-divider"></div>

      <!-- ===== Workplace Onboarding ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title">Workplace Onboarding</div>

        <router-link to="/presales/handover" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          Handover Form
        </router-link>

        <router-link to="/presales/submissions" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
          </svg>
          Submissions
        </router-link>

        <router-link to="/presales/onboarding" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
          </svg>
          Onboarding Wizard
        </router-link>
      </div>

      <div class="sidebar-divider"></div>

      <!-- ===== Deployment & Operations ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title">Deployment &amp; Operations</div>

        <router-link to="/AppDeploy-Onboarding-New" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
          </svg>
          App Deploy Onboarding
        </router-link>

        <router-link to="/pipelines-list" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/>
          </svg>
          Client Pipelines
        </router-link>

        <router-link to="/ViewAppList" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          Client Yaml Files
        </router-link>

        <router-link to="/storage-tables-list" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
          </svg>
          Client Table Viewer
        </router-link>

        <router-link to="/ClientPipelineSchedules" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Client Pipeline Schedules
        </router-link>
      </div>

      <div class="sidebar-divider"></div>

      <!-- ===== Security & Compliance ===== -->
      <div class="sidebar-section">
        <div class="sidebar-section-title">Security &amp; Compliance</div>

        <router-link to="/chat" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 3v-3z"/>
          </svg>
          Cyanic Assistant
        </router-link>

        <router-link to="/cis-benchmark" class="nav-link" active-class="active">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
          </svg>
          CIS Benchmark Comparison
        </router-link>
      </div>
    </nav>

    <!-- Main Content Area -->
    <main class="main-content">
      <slot></slot>
    </main>
  </div>
</template>

<script>
import { logout } from "@/auth.js";
import { computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import defaultPhoto from "@/assets/Default-Profile-Picture.png";

var GROUP_ROUTE_MAP = {
  identity: ['users', 'groups', 'licences'],
  security: ['security', 'conditional-access', 'authentication-methods', 'sign-in-logs'],
  applications: ['applications'],
  teams: ['teams'],
  operations: ['recommendations', 'activity', 'reports'],
  intune: ['intune/devices', 'intune/compliance', 'intune/configs', 'intune/app-protection']
};

export default {
  name: "SidebarNavigation",
  setup() {
    const store = useStore();
    const route = useRoute();
    const userIsLoggedIn = computed(() => store.state.isLoggedIn);
    const loggedInUser = computed(() => store.state.loggedInUser);
    const userPhoto = computed(() => store.state.userPhoto || defaultPhoto);
    const currentTenantId = computed(() => {
      if (route.params && route.params.tenantId) return route.params.tenantId;
      return '';
    });
    const tenantPath = computed(function() {
      var tid = currentTenantId.value;
      return tid ? '/entra/tenants/' + encodeURIComponent(tid) : '/entra/portfolio';
    });

    var expandedGroups = reactive({
      identity: false,
      security: false,
      applications: false,
      operations: false,
      intune: false
    });

    function toggleGroup(key) {
      expandedGroups[key] = !expandedGroups[key];
    }

    function autoExpandForRoute() {
      var path = route.path;
      for (var groupKey in GROUP_ROUTE_MAP) {
        var pages = GROUP_ROUTE_MAP[groupKey];
        for (var i = 0; i < pages.length; i++) {
          if (path.indexOf('/' + pages[i]) !== -1) {
            expandedGroups[groupKey] = true;
            return;
          }
        }
      }
    }

    autoExpandForRoute();

    return {
      userIsLoggedIn,
      loggedInUser,
      userPhoto,
      logout,
      defaultPhoto,
      currentTenantId,
      tenantPath,
      expandedGroups,
      toggleGroup
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

.app-layout {
  min-height: 100vh;
  background-color: #f8fafc;
}

/* Top Header */
.top-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  z-index: 1000;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}

.brand {
  display: flex;
  align-items: center;
  color: #1e293b;
  text-decoration: none;
  font-size: 1.25rem;
  font-weight: 700;
}

.brand svg {
  height: 28px;
  width: auto;
  margin-right: 0.75rem;
  color: #0d173f;
}

/* User Section in Header */
.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: background-color 0.2s;
  cursor: pointer;
}

.user-info:hover {
  background-color: #f1f5f9;
}

.profile-photo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e2e8f0;
}

.user-name {
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
}

.logout-button {
  display: flex;
  align-items: center;
  background-color: transparent;
  color: #ef4444;
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  border: 1px solid #ef4444;
  border-radius: 0.375rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  gap: 0.5rem;
  font-family: "Inter", sans-serif;
}

.logout-button:hover {
  background-color: #ef4444;
  color: white;
}

.logout-button svg {
  width: 16px;
  height: 16px;
}

/* Left Sidebar */
.sidebar {
  position: fixed;
  left: 0;
  top: 60px;
  bottom: 0;
  width: 240px;
  background-color: #ffffff;
  border-right: 1px solid #e2e8f0;
  overflow-y: auto;
  padding: 1rem 0;
}

/* Sidebar Section */
.sidebar-section {
  margin-bottom: 1.5rem;
}

.sidebar-section-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0 1rem;
  margin-bottom: 0.5rem;
}

/* Navigation Links */
.nav-link {
  display: flex;
  align-items: center;
  color: #475569;
  text-decoration: none;
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  position: relative;
}

.nav-link:hover {
  color: #1e293b;
  background-color: #f1f5f9;
}

.nav-link.active {
  background-color: var(--primary-bg, #e0e7ff);
  border-left: 3px solid var(--primary-color, #4f46e5);
  color: var(--primary-color, #4f46e5);
}

.nav-link-disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}

.nav-group-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0.5rem 1rem;
  background: none;
  border: none;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: color 0.15s;
  font-family: "Inter", sans-serif;
}
.nav-group-toggle:hover {
  color: #1e293b;
}
.nav-group-toggle .toggle-chevron {
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.nav-group-toggle.expanded .toggle-chevron {
  transform: rotate(90deg);
}

.nav-group-items {
  padding-bottom: 4px;
}

.nav-link-sub {
  padding-left: 2.5rem;
  font-size: 0.8125rem;
  font-weight: 400;
}

.nav-link-cta {
  margin: 0 0.75rem;
  border-radius: 0.5rem;
  background: linear-gradient(135deg, #eff6ff, #f0fdf4);
  border: 1px solid #bfdbfe;
  font-weight: 600;
  color: #1e40af;
}

.nav-link-cta:hover {
  background: linear-gradient(135deg, #dbeafe, #dcfce7);
  border-color: #93c5fd;
  color: #1e3a8a;
}

.nav-link-cta.active {
  background: linear-gradient(135deg, #dbeafe, #bbf7d0);
  border-color: #6366f1;
  color: #4338ca;
}

.tenant-selected-label {
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 0.75rem;
  color: #6366f1;
}

.nav-link.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: #3b82f6;
}

.nav-link svg,
.nav-link .nav-icon-img {
  width: 20px;
  height: 20px;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.section-title-with-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-logo {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  object-fit: contain;
  flex-shrink: 0;
}

/* Main Content Area */
.main-content {
  margin-left: 240px;
  margin-top: 60px;
  min-height: calc(100vh - 60px);
  overflow-y: auto;
  background-color: #f8fafc;
}

/* Divider */
.sidebar-divider {
  height: 1px;
  background-color: #e2e8f0;
  margin: 1.5rem 1rem;
}

/* Scrollbar styling for sidebar */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: #f8fafc;
}

.sidebar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
